import { render, staticRenderFns } from "./bakulator-basic.vue?vue&type=template&id=a2276c44&scoped=true&"
import script from "./bakulator-basic.vue?vue&type=script&lang=js&"
export * from "./bakulator-basic.vue?vue&type=script&lang=js&"
import style0 from "./bakulator-basic.vue?vue&type=style&index=0&id=a2276c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2276c44",
  null
  
)

export default component.exports